<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="查询编辑">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{
          $t("tab.tab_search_and_edit") }}</span>
        <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.48">
          <template #main>
            <TableMain ref="OrderForecastTable1" name="myName" :fields="fields" :title="table_title.title1"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
              :show_toolbar="true" :show_filter="true" :selectable="true" :show_email="true" :show_copy="true"
              :show_to_sale="true" :hb_table_class="'hb_table_forecast_class1'" :isBusy="isBusy_table1"
              :table_height_adjust="-8" :loading_width="40" @on_query="on_query"
              @on_cell_button_click="on_cell_button_click" @on_input="on_input" @state_change="state_change"
              :show_toolbar_button="[0, 0, 1, 1, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed"
              @email_invoke="SendEmail">
              <template #query>
                {{ $t("common.label_forecast_order_num") }}：<el-input size="small" style="width: 120px" clearable
                  v-model="ForecastSalesId">
                </el-input>
              </template>
              <template #toolbar>
                <el-button type="info" plain @click="createForm('new')" class="ml-2 iconfont icon-add-new" size="mini">
                  {{ $t("common.new") }}
                </el-button>
                <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyApproved" class="ml-2"
                  @change="myApproveChange"></el-checkbox>
              </template>
            </TableMain>
          </template>
          <template #top>
            <TableMain ref="OrderForecastTable2" :show_query_container="false" :show_date_picker="false"
              :fields="inventTable_fields" :table_height_adjust="8" :title="table_title.title2"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
              :pager_count="5" :isBusy="isBusy_table2" :only_text="$t('common.show_customer_all')"
              :only_text1="$t('common.pub_invent')" :hb_table_class="'hb_table_forecast_class2'"
              @only_methods="only_methods">
              <!-- <template #query>
            物料编号：<el-input size="small" style="width: 120px" clearable v-model="InventCode"></el-input>
          </template> -->
              <template #operation>
                <el-button type="info" plain class="ml-2" @click="OrderForecastTable2_Cell_Chose"><i
                    class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}</el-button>
              </template>
            </TableMain>
          </template>
          <template #bottom>
            <TableMain ref="OrderForecastTable3" :fields="detail_fields" :show_query_container="false"
              :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="-2"
              :show_pagination="show_pagination" :show_filter="false" :pager_count="5" :isBusy="isBusy_table3"
              :loading_width="40" :hb_table_class="'hb_table_forecast_class3'"
              @on_change="OrderForecastTable3_on_change" @state_change="OrderForecastTable3_state_change"
              :show_toolbar_button="[0, 0, 0, 0, 1]">
              <template #operation>
                <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                  @on_query="OrderForecastTable3_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
              </template>
            </TableMain>
          </template>
        </SplitContainer3>
      </el-tab-pane>
      <el-tab-pane label="明细列表">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_detail")
          }}</span>
        <OrderForecastItems></OrderForecastItems>
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_import")
          }}</span>
        <OrderForecastExport></OrderForecastExport>
      </el-tab-pane>
      <el-tab-pane label="COPACKING">
        <span slot="label"><i class="fa fa-copy" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_copacking") }}</span>
        <OrderForecastCopacking></OrderForecastCopacking>
      </el-tab-pane>
    </el-tabs>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm"
          style="height: 200px">
          <el-col :span="12">
            <el-form-item :label="$t('common.customer')" prop="CustAccountId">
              <el-select size="small" v-model="dataForm.CustAccountId" filterable clearable
                :placeholder="$t('common.action_select') + $t('common.customer')" class="w-100"
                :loading="select_loading" @change="cutChanged" :filter-method="filterMethod">
                <el-option v-for="item in cust_options" :key="item.AccountNum"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.customer_final')" prop="TEC_FinalCustAccount" v-show="false">
              <el-select size="small" v-model="dataForm.TEC_FinalCustAccount" filterable clearable
                :placeholder="$t('common.action_select') + $t('common.customer_final')" class="w-100"
                :loading="select_loading" :filter-method="filterMethod">
                <el-option v-for="item in cust_options" :key="item.AccountNum"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.sales_company')" prop="dataAreaId">
              <el-select size="small" v-model="dataForm.dataAreaId" filterable clearable
                :placeholder="$t('common.action_select') + $t('common.company')" class="w-100">
                <el-option v-for="item in company_options" :key="item.dataAreaId"
                  :label="item.dataAreaId + ':' + item.dataAreaName" :value="item.dataAreaId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.description')" prop="description">
              <el-input type="textarea" v-model="dataForm.description" rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
    <BaseModal ref="bvSaleModal" :title="$t('common.toSaleOrder')" @saveData="saveToSaleOrder">
      <template #modal_content>
        <el-form :model="dataSaleForm" :rules="SaleRules" ref="dataSaleForm" label-width="100px" class="demo-dataForm"
          style="height: 200px">
          <el-col :span="12">
            <el-form-item :label="$t('common.order_pool')" prop="SalesPoolId">
              <el-select size="small" v-model="dataSaleForm.SalesPoolId" filterable clearable
                :placeholder="$t('common.action_select') + $t('common.order_pool')" class="w-100">
                <el-option v-for="item in getBaseDataSOPool(dataSaleForm.dataAreaId)" :key="item.SalesPoolId"
                  :label="item.SalesPoolId" :value="item.SalesPoolId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.delivery_date')" prop="DeliveryDate">
              <el-date-picker size="small" type="date"
                :placeholder="$t('common.action_select') + $t('common.delivery_date')"
                v-model="dataSaleForm.DeliveryDate" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('common.description')" prop="TEC_Remark">
              <el-input type="textarea" rows="3" v-model="dataSaleForm.TEC_Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as OrderForecastController from "../../controllers/sd/OrderForecastController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as SalesOrderExportController from "../../controllers/sd/SalesOrderExportController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as notify_template from "../../shared/notify_template"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer3 from "../components/container/SplitContainer3"
import BaseModal from "../components/modals/baseModal"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"
import OrderForecastCopacking from "./OrderForecastCopacking"
import OrderForecastExport from "./OrderForecastExport"
import OrderForecastItems from "./OrderForecastItems"

export default {
  name: "OrderForecast",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
    BaseModal,
    OrderForecastExport,
    OrderForecastItems,
    OrderForecastCopacking,
  },
  data() {
    return {
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast",
        title2: "table_invent",
        title3: "table_forecast_detail",
      },
      modal_title: "create_forecast_order",
      ForecastSalesId: "",
      InventCode: "",
      fields: OrderForecastController.fields.default,
      detail_fields: OrderForecastController.fields.detail_fields,
      inventTable_fields: OrderForecastController.fields.inventTable_fields,
      dataForm: _.cloneDeep(OrderForecastController.dataForm),
      dataSaleForm: _.cloneDeep(SalesOrderController.dataForm), //转单modal
      dataItemForm: _.cloneDeep(OrderForecastController.dataItemForm),
      rules: OrderForecastController.rules,
      SaleRules: SalesOrderController.rules,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      show_pagination: true,
      select_loading: false,
      cust_options: [],
      company_options: [],
      invent_retail_options: [],
      his_order_list: [],
      his_order_line_data: [],
      all_role_users: [],
      all_role_list: [],
      onlyMyApproved: false,
      SaleAreaid: "", ///客户默认销售公司
      current_click_order: null,
      OrderForecastLine: [],
    }
  },
  async created() {
    let _fields = _.find(this.detail_fields, { key: "ModelId" })
    _.remove(_fields, (n) => {
      return n == "id"
    })
    _fields["_options"] = {
      provider: (v) => {
        let order_m = this.$refs.OrderForecastTable1.GetCurrentItem()
        let sf_models = _.filter(
          this.$store.state.biz_data.baseData.ForecastModel,
          { dataAreaId: order_m.dataAreaId }
        )
        return _.map(sf_models, (v) => {
          return {
            value: v.ModelId,
            label: v.ModelId + ": " + v.Txt,
          }
        })
      },
    }
    await this.getAllRoles()
    await this.getAllRoleUsers()
  },
  computed: {
    userCust() {
      return this.$store.state.biz_data.userInfo.user_custs
    },
  },
  watch: {
    userCust(newV, oldV) {
      if (newV && window.location.href.indexOf("?k=") > -1) {
        this.ForecastSalesId = window.location.href.split("?k=")[1]

        this.on_query(this.$refs.OrderForecastTable1.SetData)
      }
    },
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    //保存转单
    async saveToSaleOrder(cb) {
      let _this = this
      let _data = _.cloneDeep(_this.dataSaleForm)
      //数据检查
      if (_data.SalesPoolId == "" || _.isNull(_data.SalesPoolId)) {
        _this.msgToasts(this.$t("notify.not_sales_pool"), "info")
        cb(null)
        return
      }
      if (_data.DeliveryDate == "" || _.isNull(_data.DeliveryDate)) {
        _this.msgToasts(this.$t("notify.not_delivery_date"), "info")
        cb(null)
        return
      }
      this.$refs.dataSaleForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataSaleForm)
          _data.DeliveryDate = this.$date.format(
            new Date(_data.DeliveryDate),
            "yyyy-MM-dd"
          )

          ///新建时检查日期是否超过当前服务器日期
          let _is_date_ok =
            await commonController.methods.checkIsBeforeCurrentDate(
              _data.DeliveryDate
            )
          if (!_is_date_ok && _data.id == "") {
            _this.msgToasts(this.$t("notify.delivery_date_not_more_current_date"), "info")
            cb(null)
            return
          }
          let _bool = true
          _.each(this.OrderForecastLine, (t) => {
            if (t.SalesQty < 0) {
              _bool = false
            }
          })
          if (!_bool) {
            this.msgToasts(this.$t("notify.not_minus_pcs"), "error")
            cb(false)
            return
          }
          //调用订单导入接口

          let data = { username: this.$global.global_data.local_username }
          let items = []
          _.each(this.OrderForecastLine, (t) => {
            let item = {}
            item.AccountNum = _data.CustAccount
            item.dataAreaId = _data.dataAreaId
            item.ItemId = t.ItemId
            item.VariantName = t.VariantName
            item.DeliveryDate = _data.DeliveryDate
            item.SalesQty = t.SalesQty
            item.SalesPoolId = _data.SalesPoolId
            item.TEC_OtherInfo = ""
            item.TEC_CommonRemark = _data.TEC_Remark
            item.SEI_PriceUnitCust = 0
            item.SEI_OrderDateCust = this.$date.format(
              new Date(),
              "yyyy-MM-dd"
            )
            item.SEI_ShippingDateCust = _data.DeliveryDate
            items.push(item)
          })
          data.data = items
          let company = _.uniqWith(_.map(items, (t) => {
            return { dataAreaId: t.dataAreaId, accountNum: t.AccountNum }
          }), _.isEqual)
          let _gt_credit = await SalesOrderExportController.methods.pickAndInvoke(company)
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              _this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              cb(false)
              return
            }
          } else {
            _this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            cb(false)
            return
          }
          let result =
            await SalesOrderExportController.methods.SaveSaleOrderExport(
              JSON.stringify(data)
            )
          if (result[0][0].status == 0) {
            this.msgToasts(this.$t("notify.import_success"), "success")
            cb(true, true)
          } else {
            let str = "<div><strong>" + this.$t("notify.transfer_unseccess") + ":</strong></div>"
            _.each(result[0], (t) => {
              if (
                _.isNull(t.companyName) ||
                _.isNull(t.customerName) ||
                _.isNull(t.dataAreaId) ||
                t.dataAreaId == "" ||
                _.isNull(t.variantId) ||
                _.isNull(t.SalesPool) ||
                t.existsRetailVariantId == 0
              ) {
                str += this.ErrorMsg(t)
              }
            })
            this.msgToasts(str, "error", 0, true, "notify550")
            cb(false)
            return
          }
        } else {
          this.dataSaleForm.DeliveryDate = new Date()
          cb(false)
          return false
        }
      })
    },
    ErrorMsg(data) {
      if (_.isNull(data.variantId)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.variant_coding") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SalesPool)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.sales_pool") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.existsRetailVariantId == 0) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    async CurrencyChanged() {
      let _params = {
        fCur: this.dataSaleForm.CurrencyCode,
        tCur: "CNY",
      }
      let _rate = await ExchRateController.methods.getExchRate(_params)
      if (!_.isNull(_rate) && _rate && _rate.length > 0) {
        if (_.isNull(_rate[0][0].exchange_rate)) {
          this.dataSaleForm.ExchRate = 1
        } else {
          this.dataSaleForm.ExchRate = _rate[0][0].exchange_rate
        }
      }
    },
    ///获取订单池

    getBaseDataTaxGroup(_dataAreaId) {
      if (!_.isEmpty(_dataAreaId)) {
        return _.filter(this.$store.state.biz_data.baseData.TaxGroupHeading, {
          dataAreaId: _dataAreaId,
        })
      }
      return []
    },
    async getAllRoleUsers() {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_all_rolecode_username",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region table1
    ///查询
    async on_query(set_data, date_range) {
      this.OrderForecastLine = []
      //  let ckp = await this.$checkP.checkOwnPrivileges([
      //   "s-sPlant_OrderForecast",
      // ]);
      // if (!ckp) {
      //   set_data([]);
      //   return;
      // }
      let _this = this
      this.isBusy_table1 = true

      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = { is_deleted: { "=": 0 } }
      if (this.ForecastSalesId != "") {
        _params.ForecastSalesId = { like: "%" + this.ForecastSalesId + "%" }
      }
      if (!_.isNull(date_range) && this.ForecastSalesId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(this.$date.addDays(new Date(_toDate), 1), "yyyy-MM-dd")
        _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await OrderForecastController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _cust = _.find(_this.$store.state.biz_data.baseData.Customer, {
            AccountNum: t.CustAccountId,
          })
          if (_cust) {
            t.SEI_BigCustomerNumber = _cust.SEI_BigCustomerNumber
          }
          commonController.methods.getUserNameFromRole(this.all_role_users, t, "fcGetSFApprover", "SFApprover")
          let _index = _.findIndex(
            _this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccountId }
          )
          if (_index > -1) {
            _list.push(t)
          }
        })
        console.log(_list)
        this.his_order_list = _.orderBy(_list, ["id"], ["desc"])
        set_data(_.orderBy(_list, ["id"], ["desc"]))
      }
      this.isBusy_table1 = false
    },

    ///初始化so编辑界面
    async createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_forecast_order"
          this.dataForm = _.cloneDeep(OrderForecastController.dataForm)
          if (this.$refs.dataForm) {
            this.$refs.dataForm.resetFields()
          }
          this.current_click_order = null
          break
        case "edit":
          title = "edite_forecast_order"
          break
      }
      let _CustAccountId = ""
      if (!_.isNull(this.dataForm)) {
        _CustAccountId = this.dataForm.CustAccountId
      }
      this.getBaseDataCust(_CustAccountId)
      await this.getCompanys()
      this.modal_title = title
      //if(this.dataForm.dataAreaId = )
      this.$refs.bvModal.show()
    },

    ///新增修改so
    saveData(cb) {
      let _this = this
      let _data = _.cloneDeep(_this.dataForm)
      ///检查
      if (_data.CustAccountId == "" || _.isNull(_data.CustAccountId)) {
        _this.msgToasts(this.$t("notify.select_customer"), "info")
        cb(null)
        return
      }
      if (_data.dataAreaId == "" || _.isNull(_data.dataAreaId)) {
        _this.msgToasts(this.$t("notify.select_company"), "info")
        cb(null)
        return
      }
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //已审核不能修改
          let _order = _.find(_this.$refs.OrderForecastTable1.my_data, {
            id: _data.id,
          })
          if (_order && _order.fcCheckSFApproved == true) {
            _this.msgToasts(this.$t("notify.approved_can_not_be_edited"), "info")
            cb(null)
            return
          }
          ///判定能否修改订单
          if (!_.isNull(this.current_click_order)) {
            if (
              this.current_click_order.CustAccountId !=
              this.dataForm.CustAccountId ||
              this.current_click_order.dataAreaId != this.dataForm.dataAreaId
            ) {
              let _result =
                await OrderForecastController.methods.getItemDataSql({
                  order_forecast_id: parseInt(this.current_click_order.id),
                })

              if (
                !_.isNull(_result) &&
                _result &&
                _result.length > 0 &&
                _result[0].length > 0
              ) {
                _this.msgToasts(this.$t("notify.detail_created_can_not_be_edited"), "info")
                cb(null)
                return
              }
            }
          }

          if (_data.CustAccountId) {
            ///0616客户相关信息和默认销售公司没关系
            // let _SaleAreaid = this.dataForm.dataAreaId;
            // let _cust_m = _.find(this.$store.state.biz_data.baseData.Customer, {
            //   AccountNum: this.dataForm.CustAccountId,
            // });
            // if (_cust_m) {
            //   _SaleAreaid = _cust_m.SaleAreaid;
            // }
            ///查询客户相关信息
            let _result = await CustTableController.methods.getItemData({
              AccountNum: _data.CustAccountId,
              dataAreaId: this.dataForm.dataAreaId,
            })
            if (!_.isNull(_result) && _result && _result.length > 0) {
              let _m = _result[0][0]
              if (_m) {
                _data.MainContactWorker = _m.MainContactWorker
                _data.SEI_SalesGroup = _m.SEI_SalesGroup
                _data.SegmentId = _m.SegmentId
                _data.CurrencyCode = _m.Currency
                _data.InclTax = _m.InclTax
              }
            }
          }
          if (_data.CustAccountId) {
            let _m = _.find(this.$store.state.biz_data.baseData.Customer, {
              AccountNum: _data.CustAccountId,
            })
            if (_m) {
              _data.CustAccountName = _m.SEI_Name
            }
          }

          if (_data.TEC_FinalCustAccount) {
            let _m = _.find(this.$store.state.biz_data.baseData.Customer, {
              AccountNum: _data.TEC_FinalCustAccount,
            })
            if (_m) {
              _data.TEC_FinalCustAccount_Name = _m.SEI_Name
            }
          }

          delete _data.SaleAreaid
          ///保存数据
          let _rel_save_data = await OrderForecastController.methods.saveData(
            _data
          )
          if (!_.isNull(_rel_save_data)) {
            ///成功
            cb(true, true)
            if (_.isInteger(_data.id)) {
              let _cust = _.find(
                _this.$store.state.biz_data.baseData.Customer,
                { AccountNum: _data.CustAccountId }
              )
              if (_cust) {
                _data.SEI_BigCustomerNumber = _cust.SEI_BigCustomerNumber
              }
              _data.is_email_send = false
              this.$refs.OrderForecastTable1.UpdateItems(
                { id: _data.id },
                _data
              )
            } else {
              _rel_save_data[0].create_by_username =
                this.$global.global_data.local_username
              _rel_save_data[0].update_by_username =
                this.$global.global_data.local_username
              let _cust = _.find(
                _this.$store.state.biz_data.baseData.Customer,
                { AccountNum: _data.CustAccountId }
              )
              if (_cust) {
                _rel_save_data[0].SEI_BigCustomerNumber =
                  _cust.SEI_BigCustomerNumber
              }
              _rel_save_data[0].create_by_username =
                this.$global.global_data.local_username
              this.$refs.OrderForecastTable1.InsertItems(_rel_save_data[0])
            }
            ///同步客户信息并更新vuex
            // this.InvokeData(_data.CustAccountId);
          } else {
            ///失败
            cb(true, false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    ///同步当前选中客户信息
    async InvokeData(_accountNum) {
      let _params = {
        company: "070",
        tableName: "secp_sei_custtable",
        accountNum: _accountNum,
      }
      let _result = await CustTableController.methods.pickAndInvoke(_params)
      if (!_.isNull(_result) && _result && _result.status == 0) {
        ///更新vuex 数据
        this.$store.commit("update_biz_data", {
          content_path: "biz_data.baseData",
          content_type: "Customer",
          search_by: { AccountNum: _accountNum },
          data: _result.data[0],
        })
      }
    },

    ///so_order_main click
    async on_cell_button_click(data) {
      this.$refs.OrderForecastTable1.SetCurrentItem(data.item)
      ///判断是否是自己创建的数据
      if (!commonController.methods.checkIfCanModifyOrder(this, data.item)) {
        return
      }
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.current_click_order = _.cloneDeep(data.item)

      this.createForm("edit")
      //this.dataForm
    },
    on_input(data) {

    },
    ///so_order_main state change
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }

      //检查能否反审和删除
      if (data.state === "deleted") {
        ///判断是否是自己创建的数据
        let _is_my_data = true
        let _has_approve = true
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            _is_my_data = false
          } else if (t.fcCheckSFApproved == true) {
            _has_approve = false
          }
        })
        if (!_is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          cb(false)
          return
        } else if (!_has_approve) {
          this.msgToasts(this.$t("notify.has_approved"), "info")
          cb(false)
          return
        }

        let rt_check = await OrderForecastController.methods.checkUnApprove(
          data.selected_items
        )
        if (!_.isNull(rt_check) && !rt_check.state) {
          this.msgToasts(rt_check.message, "info")
          cb(false)
          return
        }
      } else if (data.state === "unapproved") {
        let _is_my_data = true
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            _is_my_data = false
          }
        })
        if (!_is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          cb(false)
          return
        }
      }

      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            //检查是否有明细
            let result = await OrderForecastController.methods.deleteData(
              data.selected_items
            )
            if (!_.isNull(result)) {
              let _is_check_list = []
              _.each(
                _.filter(result, { Code: "data/e/delete_order_forecast" }),
                (t) => {
                  if (!_.isNull(t.Result) && t.Result.Rollback) {
                    _is_check_list.push(t.Params.id)
                  }
                }
              )
              if (_is_check_list.length > 0) {
                let _msg = this.$t("notify.detail_created_can_not_be_deleted") + this.$t("common.num") + "：" + _.toString(_is_check_list)
                this.msgToasts(_msg, "info")
                cb(false)
              } else {
                let _msg = this.$t("notify.action_successfully")
                this.msgToasts(_msg, "success")
                ///删除邮件
                let notify_list = []
                _.each(data.selected_items, (t) => {
                  ///普通审批邮件
                  notify_list.push({
                    idx: t.ForecastSalesId,
                    notify_type: "sf_approve",
                  })
                })
                if (notify_list.length > 0) {
                  await commonController.methods.sendOrCancelNotify(
                    "cancel",
                    notify_list
                  )
                }
                cb(true)
                this.$refs.OrderForecastTable3.SetData([])
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (data.state === "approved" || data.state === "unapproved") {
        let _msg = data.state == "approved" ? "审批" : "反审"
        ///检查是否已经审批或反审
        let _state = data.state == "approved" ? true : false
        if (
          this.checkIsApproved(data.selected_items, "fcCheckSFApproved", _state)
        ) {
          this.msgToasts(this.$t("notify.has_approved_or_unapproved"))
          cb(false)
          return
        }
        ///检查是否有该权限
        let _check_list = await this.checkApproveStatus("approve")
        if (_check_list.length > 0 && data.state === "approved") {
          this.msgToasts(this.$t("notify.not_privileges") + this.$t("common.num") + "：" + _.join(_check_list, "，"),
            "error"
          )
          cb(false)
          return
        }
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _update_status_list = []
            let _roles = []
            if (
              this.$store.state.biz_data.userInfo.user_roles_privileges.roles
            ) {
              _roles = _.map(
                this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
                "code"
              )
            }
            let _list = _.cloneDeep(data.selected_items)
            for (var i in _list) {
              let _as_result =
                await SalesOrderController.methods.getApproveStatus({
                  DocumentType: "SalesForcast",
                  ApproveType: "",
                  ItemId: _list[i].id,
                })
              _.each(_as_result[0], (at) => {
                if (data.state == "approved") {
                  if (
                    _.includes(_roles, at.Approver) ||
                    this.$global.global_data.local_username == at.Approver
                  ) {
                    at.is_approved = true
                    at.username = this.$global.global_data.local_username
                    at.order_forecast_id = _list[i].id
                    _update_status_list.push(at)
                  }
                } else {
                  if (
                    _.includes(_roles, at.Approver) ||
                    this.$global.global_data.local_username == at.Approver ||
                    _list[i].create_by ==
                    this.$store.state.biz_data.userInfo.user_id
                  ) {
                    if (at.ApproveLevel != 1 && at.Approver == "") {
                    } else {
                      at.is_approved = false
                      at.username = this.$global.global_data.local_username
                      at.order_forecast_id = _list[i].id
                      _update_status_list.push(at)
                    }
                  }
                }
              })
            }

            let result = await OrderForecastController.methods.approveData(
              _update_status_list
            )
            if (result) {
              _.each(data.selected_items, (t) => {
                t.fcCheckSFApproved = data.state == "approved" ? true : false
                let _ap_list = _.find(_update_status_list, { ItemId: t.id })
                if (_update_status_list && data.state != "approved") {
                  // t.SOApprover = _ap_list.Approver;
                  t.is_email_send = false
                  if (this.all_role_users.length > 0) {
                    let _rn_data = []
                    _.each(this.all_role_users, (d) => {
                      if (d.role_code == _ap_list.Approver) {
                        _rn_data.push(d.username)
                      } else {
                        t.SFApprover = _ap_list.Approver
                      }
                    })
                    if (_rn_data && _rn_data.length > 0) {
                      t.SFApprover = _rn_data.join("，")
                    }
                  }
                } else {
                  t.SFApprover = ""
                }
              })
              if (data.state == "approved") {
                ///审批成功后发邮件
                let _ep = {
                  notify_type: "sf_approve_pass",
                  subject: "sf_approve_pass",
                  idx: "ForecastSalesId",
                }
                await this.sendEmailAfterApproved(data.selected_items, _ep)
              }
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (data.state == "copy") {
        if (data.selected_items.length > 1) {
          this.msgToasts(this.$t("notify.can_not_selected_multiple data"), "info")
          cb(false)
        }
        let _result = await OrderForecastController.methods.copyOrderForecast({
          ForecastSalesId: data.selected_items[0].ForecastSalesId,
        })
        if (_result && _result.length > 0) {
          if (_result[0][0].status == 0) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true)
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      } else if (data.state == "toSaleOrder") {
        //转销售订单
        ///数据检查
        //数据量检查
        if (data.selected_items.length > 1) {
          this.msgToasts(this.$t("notify.can_not_selected_multiple data"), "warning")
          cb(false)
          return
        }
        //审核状态检查
        if (!data.selected_items[0].fcCheckSFApproved) {
          this.msgToasts(this.$t("notify.unapproved_not_to_sales_order"), "warning")
          cb(false)
          return
        }
        let _result = await OrderForecastController.methods.getItemDataSql({
          order_forecast_id: parseInt(this.dataForm.id),
        })

        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.his_order_line_data = _.cloneDeep(_result[0])
          let _list = _.orderBy(
            _.filter(_result[0], { is_deleted: false }),
            ["seq"],
            ["asc"]
          )
          this.OrderForecastLine = _list
        }

        if (this.OrderForecastLine.length < 1) {
          this.msgToasts(this.$t("notify.not_detail_not_transfer_order"), "warning")
          cb(false)
          return
        }
        ///进行转单处理
        this.dataSaleForm.TaxGroup = ""
        this.dataSaleForm.SalesPoolId = ""
        this.dataSaleForm.CustAccount = data.selected_items[0].CustAccountId
        this.dataSaleForm.dataAreaId = data.selected_items[0].dataAreaId
        let _m = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: this.dataSaleForm.CustAccount,
        })
        if (_m) {
          this.dataSaleForm.SalesName = _m.SEI_Name
          this.dataSaleForm.InvoiceAccount = this.dataSaleForm.CustAccount
          this.dataSaleForm.TEC_FinalCustAccount =
            this.dataSaleForm.CustAccount
        }
        //检查预测明细列表数据
        let _bool = true
        _.each(this.OrderForecastLine, (t) => {
          if (t.SalesQty == 0 || t.SalesQty == "" || _.isNull(t.SalesQty)) {
            this.msgToasts(this.$t("notify.not_pcs"), "info")
            _bool = false
          }
          if (t.StartDate == "" || _.isNull(t.StartDate)) {
            this.msgToasts(this.$t("notify.not_delivery_date"), "info")
            _bool = false
          }
        })
        if (!_bool) {
          cb(false)
          return
        }
        this.$refs.bvSaleModal.show()
      }
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p) {
      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给创建人
      await this.exSendEmailAfterApproved(_groupby_user, _p)
      ///根据派发人发送邮件
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let cust = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: _m.CustAccountId,
        })
        if (cust && cust.EmailNotifier && cust.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(cust.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p)
      }

    },
    async exSendEmailAfterApproved(_groupby_user, _p) {
      let notify_list = []
      for (var d in _groupby_user) {
        let _list = _groupby_user[d]
        if (_list.length > 0) {
          for (var j in _list) {
            let _result = await OrderForecastController.methods.getItemDataSql({
              order_forecast_id: parseInt(_list[j].id),
            })

            if (!_.isNull(_result) && _result && _result.length > 0) {
              _list[j].children = []
              _list[j].children = _.map(_result[0], (o) => {
                return { invent_num: o.ItemId, invent_name: o.NameAlias, sales_qty: o.SalesQty }
              })
            }
          }

          let lang_code = notify_template.methods.getUserLangCode(this, d)
          let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

          let _email_params = {
            notify_type: _p.notify_type,
            subject: email_template[_p.subject],
            create_by_username: d,
            list: _list,
            idx: _p.idx,
          }
          console.log(_email_params)
          let _ep = notify_template.methods.getApprovedEmailTemplate(
            _email_params,
            this
          )
          notify_list.push(_ep)
        }

      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (t[code] == state) {
          return t
        }
      })
      return _index > -1
    },
    ///检查是否包含该审批权限
    async checkApproveStatus() {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list = this.$refs.OrderForecastTable1.GetSelectedItems()
      for (var i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesForcast",
          ApproveType: "",
          ItemId: t.id,
        })
        let _is_ok = true
        for (var j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _is_ok = false
            }
          }
        }
        if (_is_ok && !_.includes(_check_list, t.id)) {
          _check_list.push(t.id)
        }
      }
      return _check_list
    },
    tool_invoke(data) { },
    async current_changed(old, current) {
      this.$refs.OrderForecastTable2.only_value = false
      this.$refs.OrderForecastTable2.only_value1 = false
      if (_.isNull(current)) {
        this.$refs.OrderForecastTable3.SetData([])
        this.$refs.OrderForecastTable2.SetData([])
        return
      }

      this.isBusy_table3 = true
      for (var i in this.dataForm) {
        this.dataForm[i] = current[i]
      }

      ///get invent
      this.OrderForecastTable2_query(false)
      let _fields = _.find(this.detail_fields, {
        key: "ModelId",
      })
      _.remove(_fields, (n) => {
        return n == "id"
      })
      let filter = _.filter(this.$store.state.biz_data.baseData.ForecastModel, {
        dataAreaId: current.dataAreaId,
      })
      _fields["_options"] = {
        provider: (v) => {
          return _.map(filter, (v) => {
            return {
              value: v.ModelId,
              label: v.ModelId + ": " + v.Txt,
            }
          })
        },
      }
      //get items
      await this.getSOItems()
      this.isBusy_table3 = false
    },

    async getSOItems() {
      let _this = this
      this.$refs.OrderForecastTable3.SetData([])
      let _result = await OrderForecastController.methods.getItemDataSql({
        order_forecast_id: parseInt(this.dataForm.id),
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.his_order_line_data = _.cloneDeep(_result[0])
        let _list = _.orderBy(
          _.filter(_result[0], { is_deleted: false }),
          ["seq"],
          ["asc"]
        )
        _.each(_list, (t) => {
          t.old_SalesQty = t.SalesQty
          // _this.getInventData(t.ItemId);
        })
        this.OrderForecastLine = _list
        this.$refs.OrderForecastTable3.SetData(_list)
      }
    },

    ///初始化 cust
    getBaseDataCust(v) {
      console.log(v)
      this.cust_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.userInfo.user_custs,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)

      this.cust_options = _.filter(this.cust_options, function (o) {
        return o.Blocked.indexOf("否") != -1
      })
      console.log(this.cust_options)
      if (v != "") {
        console.log(this.cust_options)
        let _index = _.findIndex(this.cust_options, { AccountNum: v })

        // let _index = _.findIndex(this.cust_options, {
        //   AccountNum: this.dataForm.CustAccount,
        // });
        // if (_index < 0 && v == "edit") {
        //   let _m = _.find(this.$store.state.biz_data.userInfo.user_custs, {
        //     AccountNum: this.dataForm.CustAccount,
        //   });
        //   this.cust_options.push(_m);
        // }
        if (_index < 0) {
          let _m = _.find(this.$store.state.biz_data.userInfo.user_custs, {
            AccountNum: v,
          })
          this.cust_options.push(_m)
        }
      }
    },

    ///筛选cust
    filterMethod(v) {
      if (v) {
        let _filter_list = _.filter(
          _.cloneDeep(
            _.orderBy(
              this.$store.state.biz_data.userInfo.user_custs,
              ["modifiedDateTime"],
              ["desc"]
            )
          ),
          function (t) {
            return t.AccountNum.indexOf(v) > -1 || t.SEI_Name.indexOf(v) > -1
          }
        )
        _filter_list = _.filter(_filter_list, function (o) {
          return o.Blocked.indexOf("否") != -1
        })

        this.cust_options = _filter_list.splice(0, 300)
      } else {
        this.cust_options = _.cloneDeep(
          _.orderBy(
            this.$store.state.biz_data.userInfo.user_custs,
            ["modifiedDateTime"],
            ["desc"]
          )
        ).splice(0, 300)
        this.cust_options = _.filter(this.cust_options, function (o) {
          return o.Blocked.indexOf("否") != -1
        })
      }
    },
    async cutChanged() {
      if (this.dataForm.CustAccountId != "") {
        this.dataForm.dataAreaId = ""
        this.dataForm.TEC_FinalCustAccount = this.dataForm.CustAccountId
        await this.getCompanys()
      }
    },
    async getCompanys() {
      //  let ckp = await this.$checkP.checkOwnPrivileges([
      //   "s-CustTable",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      let _this = this
      this.company_options = []
      let _result = await CustTableController.methods.getItemData({
        AccountNum: { "=": this.dataForm.CustAccountId },
        Blocked: { "=": "否" },
      })


      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          let _dataArea_m = _.find(
            this.$store.state.biz_data.baseData.CompanyInfo,
            { DataArea: t.dataAreaId }
          )
          if (_dataArea_m) {
            let _cut_m = _.find(_this.$store.state.biz_data.baseData.Customer, {
              AccountNum: _dataArea_m.CustAccountNum,
            })
            t.dataAreaName = _cut_m.SEI_Name
          }
        })
        this.company_options = _.orderBy(_result[0], ["id"], ["asc"])
        let _customer = _.find(_this.$store.state.biz_data.baseData.Customer, {
          AccountNum: this.dataForm.CustAccountId,
        })
        if (
          _customer &&
          _customer.SaleAreaid &&
          !_.isNull(_customer.SaleAreaid)
        ) {
          let _index = _.findIndex(this.company_options, {
            dataAreaId: _customer.SaleAreaid,
          })
          if (_index > -1) {
            this.dataForm.dataAreaId = _customer.SaleAreaid
          } else if (_result[0] && _result[0].length > 0) {
            this.dataForm.dataAreaId = _result[0][0].dataAreaId
          }
        } else if (_result[0] && _result[0].length > 0) {
          this.dataForm.dataAreaId = _result[0][0].dataAreaId
        }
      }
    },
    ///获取订单池
    getBaseDataSOPool(_dataAreaId) {
      if (!_.isEmpty(_dataAreaId)) {
        return _.filter(this.$store.state.biz_data.baseData.SalesPool, {
          dataAreaId: _dataAreaId,
        })
      }
      return []
    },

    //#endregion

    //#region table2
    //查询物料
    async OrderForecastTable2_query(itemFilter) {
      this.isBusy_table2 = true
      this.$refs.OrderForecastTable2.SetData([])
      let _mt_m = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (!_mt_m) {
        this.isBusy_table2 = false
        this.msgToasts(this.$t("notify.not_selected_data"), "info")
        return
      }
      let _p = {}
      _p.dataAreaId = _mt_m.dataAreaId
      if (itemFilter) {
        if (itemFilter.public) {
          _p.publicItem = 1
        }
        if (!itemFilter.allCust) {
          if (_mt_m && !_.isNull(_mt_m)) {
            _p.CustAccount = _mt_m.CustAccountId
          }
        }
      } else {
        if (_mt_m && !_.isNull(_mt_m)) {
          _p.CustAccount = _mt_m.CustAccountId
        }
      }
      let _result = await InventTableController.methods.getSOInventData(_p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.OrderForecastTable2.SetData(
          _.orderBy(_result[0], ["createdDateTime"], ["desc"])
        )
      }
      this.isBusy_table2 = false
    },
    // 物料选择
    OrderForecastTable2_Cell_Chose() {
      let _this = this
      let _master_m = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (_master_m && _master_m.is_deleted == true) {
        this.msgToasts(this.$t("notify.not_created_forecast_detail"), "info")
        return
      }
      if (!_.isInteger(this.dataForm.id)) {
        this.msgToasts(this.$t("notify.not_selected_data"), "info")
        return
      }
      if (_.isEmpty(this.$refs.OrderForecastTable2.GetSelectedItems())) {
        this.msgToasts(this.$t("notify.not_selected_invent"), "info")
        return
      }

      let _invent_select_items =
        this.$refs.OrderForecastTable2.GetSelectedItems()
      if (_invent_select_items && _invent_select_items.length > 0) {
        let _append_items = []
        let _dt = _.cloneDeep(_invent_select_items)
        let his_soline_last_num = 0
        if (this.his_order_line_data.length > 0) {
          his_soline_last_num = _.orderBy(
            this.his_order_line_data,
            ["seq"],
            ["desc"]
          )[0].seq
        }
        let soline_temp_linenum = _.filter(
          this.$refs.OrderForecastTable3.my_data,
          { id: "" }
        ).length
        let _seq = 1
        _.each(_dt, (t) => {
          let _item = _.cloneDeep(this.dataItemForm)
          _item.id = ""
          _item.ItemId = t.ItemId
          _item.NameAlias = t.NameAlias

          _item.SalesUnitId = t.DW_InventUnitId
          _item.SEI_DimensionFG = t.SEI_DimensionFG //维度
          _item.SalesQty = 0
          _item.old_SalesQty = 0
          _item.valid_remain = 0
          _item.description = ""

          _item.is_invent_ready = false
          _item.StartDate = new Date()

          let _index = _.findIndex(this.$refs.OrderForecastTable3.my_data, {
            ItemId: t.ItemId,
            is_deleted: false,
          })
          if (_index < 0) {
            _item.seq = his_soline_last_num + soline_temp_linenum + _seq
            if (!_.isNull(t.RetailVariantId) && !_.isEmpty(t.RetailVariantId)) {
              _item.RetailVariantId = t.RetailVariantId
            }
            _item.VariantName = t.VariantName
            _append_items.push(_item)
            // _this.getInventData(_item.ItemId);
            _seq += 1
          }
        })

        if (this.$refs.OrderForecastTable3.my_data.length > 0) {
          this.$refs.OrderForecastTable3.AppendItems(_append_items)
        } else {
          this.$refs.OrderForecastTable3.SetData(_append_items)
        }
        if (
          this.$refs.OrderForecastTable3.my_data &&
          this.$refs.OrderForecastTable3.my_data.length > 50
        ) {
          this.show_pagination = true
        }
        this.$refs.OrderForecastTable2.UnSelectAll()
      }
    },
    only_methods(isAllCust, isPublic) {
      this.$refs.OrderForecastTable2.SetData([])
      this.OrderForecastTable2_query({ allCust: isAllCust, public: isPublic })
    },
    //#endregion

    //#region table3
    ///状态切换
    OrderForecastTable3_state_change(data, cb) {
      ///判断是否是自己创建的数据
      let _mt = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (!commonController.methods.checkIfCanModifyOrder(this, _mt)) {
        cb(false)
        return
      }
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let _sf_main = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (_sf_main && _sf_main.fcCheckSFApproved) {
        this.msgToasts(this.$t("notify.unapproved_not_deleted_detail"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let has_id_list = _.filter(
              _.cloneDeep(data.selected_items),
              function (t) {
                return t.id != ""
              }
            )
            let not_id_list = _.filter(
              _.cloneDeep(data.selected_items),
              function (t) {
                return t.id == ""
              }
            )

            if (has_id_list && has_id_list.length > 0) {
              this.isBusy_table3 = true
              let result = await OrderForecastController.methods.deleteItemData(
                has_id_list
              )
              if (!_.isNull(result)) {
                let is_ok = true
                let _error_ids = []
                let check_filter = _.filter(result, {
                  Code: "data/d/sPlant_OrderForecast_Line",
                })
                _.each(check_filter, (t) => {
                  if (t.Result && t.Result.Rollback) {
                    is_ok = false
                    let _m = _.find(_.cloneDeep(data.selected_items), {
                      id: t.Params.id,
                    })
                    if (_m) {
                      _error_ids.push(_m)
                    }
                  }
                })
                console.log(check_filter)
                if (is_ok) {
                  this.msgToasts(this.$t("notify.action_successfully"), "success")
                  this.$refs.OrderForecastTable3.RemoveItems(
                    _.differenceBy(has_id_list, _error_ids, "id")
                  )

                  if (not_id_list.length > 0) {
                    this.$refs.OrderForecastTable3.RemoveItems(not_id_list)
                    let _seq =
                      _.orderBy(this.his_order_line_data, ["seq"], ["desc"])[0]
                        .seq + 1
                    _.each(
                      _.filter(this.$refs.OrderForecastTable3.my_data, {
                        id: "",
                      }),
                      (t) => {
                        t.seq = _seq
                        _seq += 1
                      }
                    )
                  }
                  cb(true)
                } else {
                  this.msgToasts(
                    this.$t("notify.dispatched_not_deleted") + this.$t("common.line_num") + "：" + _.join(_.map(_error_ids, "seq"), "，"),
                    "info"
                  )
                  cb(false)
                }
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
              this.isBusy_table3 = false
            } else if (not_id_list.length > 0) {
              this.$refs.OrderForecastTable3.RemoveItems(not_id_list)
              if (this.his_order_line_data.length > 0) {
                let _seq =
                  _.orderBy(this.his_order_line_data, ["seq"], ["desc"])[0]
                    .seq + 1
                _.each(
                  _.filter(this.$refs.OrderForecastTable3.my_data, { id: "" }),
                  (t) => {
                    t.seq = _seq
                    _seq += 1
                  }
                )
              }
            }
          }
        })
      }
    },
    async OrderForecastTable3_on_change(data) {
      if (data.field.key == "SalesQty") {
        let result = await OrderForecastController.methods.getDispatchedQty(
          data.item.id
        )
        if (!_.isNull(result)) {


          let _td = 0
          if (!_.isNull(result[0][0].totalDispatchedQty)) {
            _td = result[0][0].totalDispatchedQty
          }
          data.item.valid_remain =
            parseFloat(data.item.SalesQty) - parseFloat(_td)
        }

        // ///修改剩余派单数量
        // if (_.isInteger(data.item.id)) {
        //   let _m = _.find(this.his_order_line_data, { id: data.item.id })

        //   let chang_qty = parseFloat(data.item.SalesQty) - parseFloat(_m.SalesQty)
        //   if (chang_qty > 0) {
        //     data.item.valid_remain = parseFloat(data.item.valid_remain) + parseFloat(chang_qty);
        //   }

        //   if (chang_qty == 0) {
        //     data.item.valid_remain = _m.valid_remain
        //   }
        // } else {
        //   data.item.valid_remain = parseFloat(data.item.SalesQty);
        // }
        // console.log(data.item);
        // this.$refs.OrderForecastTable3.UpdateItems(
        //   { ItemId: data.item.ItemId, seq: data.item.seq },
        //   data.item
        // );
      } else if (data.field.key == "RetailVariantId") {
        let _m = _.find(this.invent_retail_options, {
          ItemId: data.item.ItemId,
          seq: data.item.seq,
        })
        if (_m) {
          let _t = _.find(_m.options, {
            RetailVariantId: data.item.RetailVariantId,
          })
          if (_t) {
            data.item.VariantName = _t.VariantName
          }
        }
      }
    },
    ///保存订单明细
    async OrderForecastTable3_SaveData(cb) {
      if (this.$refs.OrderForecastTable3.my_data.length == 0) {
        cb(true)
        return
      }
      ///判断是否是自己创建的数据
      let _mt = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (!commonController.methods.checkIfCanModifyOrder(this, _mt)) {
        cb(false)
        return
      }
      if (this.$refs.OrderForecastTable3.my_data.length == 0) {
        cb(true)
        return
      }
      //检查数量
      let _qty_check_ok = true
      let _deliver_date_check_ok = true
      let _modelId_check_ok = true
      let _is_accuracy_ok = true
      _.each(this.$refs.OrderForecastTable3.my_data, (t) => {
        if (t.SalesQty == 0 || t.SalesQty == "" || _.isNull(t.SalesQty)) {
          _qty_check_ok = false
        }
        if (_.isNull(t.StartDate) || t.StartDate == "") {
          _deliver_date_check_ok = false
        }
        if (_.isNull(t.ModelId) || t.ModelId == "") {
          _modelId_check_ok = false
        }
        if (
          _.isNull(t.SEI_ForecastAccuracy) ||
          t.SEI_ForecastAccuracy == "" ||
          parseFloat(t.SEI_ForecastAccuracy) > 100
        ) {
          _is_accuracy_ok = false
        }
      })

      if (!_qty_check_ok) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        cb(true)
        return
      } else if (!_deliver_date_check_ok) {
        this.msgToasts(this.$t("notify.not_delivery_date"), "info")
        cb(true)
        return
      } else if (!_modelId_check_ok) {
        this.msgToasts(this.$t("notify.not_modal"), "info")
        cb(true)
        return
      } else if (!_is_accuracy_ok) {
        this.msgToasts(this.$t("notify.not_accuracy_of_prediction"), "info")
        cb(true)
        return
      }

      //检查
      let _check_list = _.filter(
        this.$refs.OrderForecastTable3.my_data,
        function (t) {
          if (_.isNull(t.StartDate)) {
            return t
          }
        }
      )
      if (_check_list && _check_list.length > 0) {
        this.msgToasts(this.$t("notify.not_delivery_date"), "info")
        cb(true)
        return
      }
      let _order_m = this.$refs.OrderForecastTable1.GetCurrentItem()
      if (_order_m && _order_m.fcCheckSFApproved == true) {
        this.msgToasts(this.$t("notify.approved_can_not_be_edited"), "info")
        cb(true)
        return
      }

      this.OrderForecastTable3_excut_save(cb)
    },

    ///保存订单
    async OrderForecastTable3_excut_save(cb) {
      let _this = this
      let _so_items = []
      let _mt = this.$refs.OrderForecastTable1.GetCurrentItem()
      for (var i in this.$refs.OrderForecastTable3.my_data) {
        let _data = _.cloneDeep(this.$refs.OrderForecastTable3.my_data[i])
        let _cust = _.find(_this.$store.state.biz_data.baseData.Customer, {
          AccountNum: _data.CustAccountId,
        })
        if (_cust) {
          _data.Currency = _cust.Currency
        }

        if (_mt) {
          _data.documentCreateByUsername =
            this.$global.global_data.local_username
          _data.order_forecast_id = _mt.id
          _data.ForecastSalesId = _mt.ForecastSalesId
        }

        if (_.isDate(_data.StartDate)) {
          _data.StartDate = _this.$date.format(_data.StartDate, "yyyy-MM-dd")
        }

        delete _data.old_SalesQty
        ///再次查询派发数量
        if (_.isInteger(_data.id)) {
          let result = await OrderForecastController.methods.getDispatchedQty(_data.id)
          if (!_.isNull(result)) {
            let _totalDispatchedQty = 0
            if (!_.isNull(result[0][0].totalDispatchedQty)) {
              _totalDispatchedQty = result[0][0].totalDispatchedQty
            }
            _data.valid_remain = parseFloat(_data.SalesQty) - parseFloat(_totalDispatchedQty)
          }
        }
        _so_items.push(_data)
      }
      let _rel_save_data = await OrderForecastController.methods.saveItems(_so_items)
      cb(true)
      if (!_.isNull(_rel_save_data)) {
        let error_notice_list = []
        let _is_ok = true
        //检查能否修改
        let _check_list = _.filter(_rel_save_data, {
          Code: "data/u/sPlant_OrderForecast_Line",
        })
        if (_check_list && _check_list.length > 0) {
          _.each(_check_list, (t) => {
            if (t.Result && t.Result.Rollback) {
              _is_ok = false
              let _m = _.find(_.cloneDeep(_so_items), { id: t.Params.id })
              if (_m) {
                error_notice_list.push(_m)
              }
            }
          })
        }
        if (_is_ok) {
          ///成功
          this.msgToasts(this.$t("notify.action_successfully"), "success")

          ///修改订单信息
          let _so_resault_list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/s/sPlant_OrderForecast") > -1
          })

          if (_so_resault_list && _so_resault_list.length > 0) {
            _.each(_so_resault_list, (t) => {
              let reOrder = t.Result.Data[0][0]
              reOrder.is_email_send = false
              commonController.methods.getUserNameFromRole(
                this.all_role_users,
                reOrder,
                "fcGetSFApprover",
                "SFApprover"
              )
              _this.$refs.OrderForecastTable1.UpdateItems(
                { id: reOrder.id },
                reOrder
              )
            })
          }
          ///修改订单明细信息
          let _list = _.filter(_rel_save_data, function (t) {
            return (
              t.Code.indexOf("data/i/sPlant_OrderForecast_Line") > -1 ||
              t.Code.indexOf("data/u/sPlant_OrderForecast_Line") > -1
            )
          })
          // console.log(_list)
          if (_list && _list.length > 0) {
            _.each(_list, (t) => {
              if (t.Result && t.Result.Data && t.Result.Data.length > 0) {
                let res_m = t.Result.Data[0][0]
                _this.$refs.OrderForecastTable3.UpdateItems(
                  {
                    ItemId: res_m.ItemId,
                    seq: res_m.seq,
                  },
                  res_m
                )
                let _index = _.findIndex(this.his_order_line_data, {
                  id: res_m.id,
                })
                if (_index < 0) {
                  this.his_order_line_data.push(res_m)
                }
              }
            })
          }
        } else {
          console.log(error_notice_list)
          this.msgToasts(
            this.$t("notify.updated_pcs_not_more_dispatched_pcs") + this.$t("common.line_num") + "：" +
            _.map(error_notice_list, "seq").join(","),
            "error"
          )
        }
      } else {
        ///失败
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },

    //#endregion

    ///变形编号
    setInventData(_itemId) {
      let _m = _.find(this.invent_retail_options, { ItemId: _itemId })
      if (_m) {
        return _m.options
      }
      return []
    },
    ///获取物料相关信息
    async getInventData(_itemId) {
      if (_.isNull(_itemId)) {
        return
      }
      let _result = await InventTableController.methods.getItemData({
        // ItemId: { "=": _itemId }
        ItemId: _itemId,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], (t) => {
          return t.RetailVariantId != ""
        })
        // console.log(_list);
        let _p = {
          ItemId: _itemId,
          options: _list,
        }
        let _index = _.findIndex(this.invent_retail_options, (t) => {
          return t.ItemId == _p.ItemId
        })
        if (_index < 0) {
          this.invent_retail_options.push(_p)
        }
      }
    },
    ///订单审批邮件模板
    orderEmailTemplate(_selectedlist) {
      let _this = this
      let _params = {}
      let notify_list = []
      _.each(_selectedlist, async (t) => {
        let company_name = ""
        let _company_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo,
          { DataArea: t.dataAreaId }
        )
        if (_company_m) {
          company_name = _company_m.CompanyName
        }

        let lang_code = notify_template.methods.getUserLangCode(this, t.SFApprover)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _notify_p = {
          category: "sf_approve",
          idx: t.ForecastSalesId,
          itemId: t.id,
          notify_type: "sf_approve",
          subject: email_template["forecast_approved_be_care"],
          content: "",
        }
        _params.email_user = t.SFApprover
        _params.main = {
          type_name: "预测订单审批",
          url: window.location.protocol + "//" + window.location.host + "/sd/OrderForecast?k=" + t.ForecastSalesId,
          url_name: window.location.host + "/sd/OrderForecast?k=" + t.ForecastSalesId,
          forcast_code: t.ForecastSalesId,
          customer_name: t.CustAccountName,
          sales_company: company_name,
          username: this.$global.global_data.local_username,
          create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        }

        let _index = _.findIndex(notify_list, { idx: t.ForecastSalesId })
        if (_index < 0) {
          _notify_p.content = notify_template.methods.getForcastTemplate(_params, this)
          notify_list.push(_notify_p)
        }
      })
      return notify_list
    },
    validEmailSend(_list) {
      ///判断是否是自己创建的数据
      let _is_my_data = true
      _.each(_list, (t) => {
        if (
          t.create_by &&
          t.create_by != this.$store.state.biz_data.userInfo.user_id
        ) {
          _is_my_data = false
        }
      })
      if (!_is_my_data) {
        this.msgToasts(this.$t("notify.not_created_by_yourself"))
        return false
      }
      return true
    },
    ///send email
    SendEmail(data) {
      let _this = this
      let _list = _.orderBy(
        this.$refs.OrderForecastTable1.GetSelectedItems(),
        ["id"],
        ["desc"]
      )
      ///检查
      if (!this.validEmailSend(_list)) {
        return
      }

      if (_list.length > 0) {
        if (data.code == "add") {
          this.msgModal(this.$t("notify.is_send_email")).then(async (v) => {
            if (v) {
              let _so_ids = []
              _.each(_list, async (t) => {
                _so_ids.push(t.id)
              })

              let notify_list = []

              //====审批
              let order_email_list = _.filter(_list, {
                fcCheckSFApproved: false,
              })
              let _order_email_temp_list =
                this.orderEmailTemplate(order_email_list)
              if (_order_email_temp_list.length > 0) {
                notify_list = _.union(notify_list, _order_email_temp_list)
              }

              // console.log(notify_list)
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.email_seccess"), "success")
                  await commonController.methods.updateEmailSendState(
                    "sf",
                    _list
                  )
                  _.each(_list, (t) => {
                    t.is_email_send = true
                  })
                }
              } else if (_list.length > 0 && notify_list.length == 0) {
                _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info")
              }
            }
          })
        } else {
          this.msgModal(this.$t("notify.is_repeal_email")).then(async (v) => {
            if (v) {
              let notify_list = []
              _.each(_list, (t) => {
                ///普通审批邮件
                notify_list.push({
                  idx: t.ForecastSalesId,
                  notify_type: "sf_approve",
                })
              })
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.approved_email_cancel_success"), "success")
                }
              }
            }
          })
        }
      } else {
        this.msgToasts(this.$t("notify.not_data"), "info")
      }
    },
    async myApproveChange() {
      let _role_code = ""
      let _username = this.$global.global_data.local_username
      if (this.onlyMyApproved) {
        if (this.$refs.OrderForecastTable1.my_data.length == 0) {
          this.onlyMyApproved = false
          this.msgToasts(this.$t("notify.excute_search_before"), "info")
          return
        }
        let _result = await api.query_async({
          url: apiPath.user.profile,
          parameters: null,
          method: "get",
        })
        if (
          _result &&
          !_.isNull(_result) &&
          _result[0] &&
          _result[0].result &&
          _result[0].result.data &&
          _result[0].result.data.Result
        ) {
          _role_code = _result[0].result.data.Result.roles[0].code
        }
        let _list = []
        _.each(this.$refs.OrderForecastTable1.my_data, (t) => {
          if (!_.isNull(t.fcGetSFApprover) && t.fcGetSFApprover) {
            let name_or_role = t.fcGetSFApprover.split(",")[0]
            let _is_role = t.fcGetSFApprover.split(",")[1]
            if (_is_role == 1) {
              if (name_or_role == _role_code) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
        })
        this.$refs.OrderForecastTable1.SetData(
          _.orderBy(_list, ["id"], ["desc"])
        )
      } else {
        this.$refs.OrderForecastTable1.SetData(this.his_order_list)
      }
    },
  },
}
</script>

<style>
.hb_table_forecast_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 150rem;
}

.hb_table_forecast_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 65rem;
}

.hb_table_forecast_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 115rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
